import React from 'react';
import {
  Input,
  TextArea,
  Form,
  Dropdown,
  Checkbox,
  Button,
  Table,
  Loader,
} from 'semantic-ui-react';
import * as action from '../../../actions/newYouslim';
import TagsBlock from '../TagsBlock';
import VideoModal from '../../Videos/VideoModal';
import { connect } from 'react-redux';
import {
  LinkBlock,
  StyledLink,
  MainTitle,
  ProductNameBlock,
  TagsGroup,
  Label,
  LoaderBlock,
  ButtonGroupBlock,
  ButtonBlock,
  DishCountBlock,
  DishTitleLabel,
  NameBlock,
  DeleteButton,
  EditButton,
  PlayButton,
  Img,
  FooterBlock,
} from '../CreateTrainingList/TrainingList';
import { TableBlock, H2 } from '../CreateProductPage/CreateProductStyles';
import debounce from '../../../utils/debounce';
import { defaulIsDraftArray } from '../youslim2.0_Constants';
import DeleteConfirmPopup from '../../Common/DeleteConfirmPopup';
import EditIcon from '../../../images/edit_icon.png';
import Navbar from '../Navigation/Navbar';
const CreateTrainingList = ({
  getComplexity,
  getTrainingType,
  getTrainingGears,
  complexity,
  trainingType,
  trainingGears,
  training,
  getTrainingListByName,
  deleteTraining,
  isSearchTrainingLoading,
  setIsVideoModalOpen,
  setActiveVideo,
  isVideoModalOpen,
  activeVideo,
  setCurrentTraining,
  checkShouldTrainBeDeleted,
  isTrainingDelete,
}) => {
  const [trainType, setTrainType] = React.useState([]);
  const [trainComplexity, setTrainComplexity] = React.useState([]);
  const [trainGears, setTrainGears] = React.useState([]);
  const [isShowDeletePopup, setIsShowDeletePopup] = React.useState(false);
  const [trainCurrentName, setTrainCurrentName] = React.useState('');
  const [trainingList, setTrainingList] = React.useState([...training]);
  const [trainingCurrentId, setTrainingCurrentId] = React.useState(0);
  const [trainCurrentId, setTrainCurrentId] = React.useState(0);
  const [isOpenTrainingInfo, setIsOpenTrainingInfo] = React.useState([false]);
  const [trainingCount, setTrainingCount] = React.useState(0);
  const [isDraftSelectValue, setIsDraftSelectValue] = React.useState('all');
  const [currentListIndex, setCurrentListIndex] = React.useState(0);

  React.useEffect(() => {
    getComplexity();
    getTrainingType();
    getTrainingGears();
    getTrainingListByName();
  }, []);

  React.useEffect(() => {
    const newTrainingItems = [];
    const newTrainingList = trainingList;
    const oldTrainingList = training;
    newTrainingList[currentListIndex] = newTrainingItems;
    setTrainingList(...newTrainingList);
  }, [training, setTrainingList, currentListIndex, setCurrentListIndex]);

  React.useEffect(() => {
    if (training) setTrainingList([...training]);
    const trainingCount = [];
    training.forEach(() => {
      trainingCount.push(false);
    });
    setIsOpenTrainingInfo([...trainingCount]);
  }, [training]);

  React.useEffect(() => {
    const allTags = [...trainType, ...trainComplexity, ...trainGears];
    getTrainingListByName(trainCurrentName, trainType, trainComplexity, trainGears);
  }, [trainCurrentName, trainType, trainComplexity, trainGears]);

  const onSearchTraining = React.useCallback(
    debounce((name) => {
      setTrainCurrentName(name);
    }, 1000),
    [getTrainingListByName, trainType, trainComplexity, trainGears],
  );

  const onIsDraftSelect = React.useCallback(
    (data) => {
      setIsDraftSelectValue(data.value);
      changeIsDraft(data.value);
    },
    [setIsDraftSelectValue, training],
  );

  const changeIsDraft = React.useCallback(
    (isDraftValue) => {
      let trainListArray = training;
      const newTrainList = [];
      const newIsDraftList = [];
      if (isDraftValue !== 'all') {
        if (newTrainList.length) trainListArray = newTrainList;
        trainListArray.forEach((train) => {
          if (train.is_draft !== isDraftValue) return;
          newIsDraftList.push(train);
        });
        if (newIsDraftList.length) {
          setTrainingList([...newIsDraftList]);
        } else setTrainingList([...newTrainList]);
      }
    },
    [training],
  );

  const ClearSort = React.useCallback(() => {
    setTrainingList([...training]);
  }, [setTrainingList]);
  const showVideo = React.useCallback(
    (video) => {
      setIsVideoModalOpen(true);
      setActiveVideo(video);
    },
    [setIsVideoModalOpen, setActiveVideo],
  );

  const onDelete = React.useCallback(() => {
    deleteTraining(trainingCurrentId);
    setIsShowDeletePopup(false);
  }, [deleteTraining, trainingCurrentId]);

  const confirmDeleting = React.useCallback(
    (name, id) => {
      setTrainCurrentName(name);
      setTrainCurrentId(id);
      setIsShowDeletePopup(true);
      checkShouldTrainBeDeleted(id);
      setTrainingCurrentId(id);
    },
    [setTrainCurrentName, setTrainCurrentId, setIsShowDeletePopup, setTrainingCurrentId],
  );

  const onEditClick = React.useCallback(
    (train) => {
      const newTraining = {};
      newTraining.name = train.title;
      newTraining.id = train.id;
      newTraining.description = train.description;
      newTraining.complexity_training = train.complexity_training.name;
      newTraining.type_video_training = train.type_video_training.name;
      if (newTraining.preview) train.preview_file;
      if (newTraining.video) train.video_file.url;
    
      if (newTraining.time_stamps) train.video_file.time_stamps;
  
      if (newTraining.gears) train.gears;
      setCurrentTraining(newTraining);
    },
    [setCurrentTraining],
  );
  return (
    <React.Fragment>
      <Navbar />
      <MainTitle>Список Дневных тренировок</MainTitle>
      <ProductNameBlock>
        <Label>Поиск по названию</Label>
        <Input
          type="search"
          placeholder="Введите название тренировки"
          style={{ width: '100%', margin: '15px' }}
          className="template-name-input"
          onChange={(e) => onSearchTraining(e.target.value)}
        />
        <Dropdown
          placeholder="Найти по статусу публикации"
          fluid
          style={{ width: '20%' }}
          search
          selection
          options={defaulIsDraftArray}
          value={isDraftSelectValue}
          onChange={(e, data) => onIsDraftSelect(data)}
        />
      </ProductNameBlock>
      <TagsGroup>
        <TagsBlock
          allTags={trainingType}
          choosedTags={trainType}
          setChoosedTags={setTrainType}
          height="200px"
          flexBasis="16%"
          width="20%"
          title="Тип тренировки"
        />
        <TagsBlock
          allTags={complexity}
          choosedTags={trainComplexity}
          setChoosedTags={setTrainComplexity}
          height="200px"
          flexBasis="16%"
          width="20%"
          title="сложность"
        />
        <TagsBlock
          allTags={trainingGears}
          choosedTags={trainGears}
          setChoosedTags={setTrainGears}
          height="200px"
          flexBasis="20%"
          width="60%"
          title="инвентарь"
        />
      </TagsGroup>
      <ButtonGroupBlock>
        <Button.Group>
          <Button positive>Искать тренировки</Button>
        </Button.Group>
      </ButtonGroupBlock>
      {trainingList.length ? (
        <DishCountBlock>Количество тренировок: {trainingList.length}</DishCountBlock>
      ) : (
        ''
      )}
      <TableBlock>
        {trainingList.length ? (
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  <ButtonBlock>
                    <DishTitleLabel>
                      id <br />
                    </DishTitleLabel>
                  </ButtonBlock>
                </Table.HeaderCell>
                <Table.HeaderCell>Название</Table.HeaderCell>
                <Table.HeaderCell>Сложность</Table.HeaderCell>
                <Table.HeaderCell>Тип</Table.HeaderCell>
                <Table.HeaderCell>Инвентарь</Table.HeaderCell>
                <Table.HeaderCell>Описание</Table.HeaderCell>
                <Table.HeaderCell collapsing>
                  <Button size="mini" onClick={() => ClearSort()}>
                    Сбросить <br /> сортировку
                  </Button>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {trainingList.map((train, index) => {
                return (
                  <Table.Row>
                    <React.Fragment>
                      <Table.Cell>
                        <NameBlock>{train && train.id}</NameBlock>
                      </Table.Cell>
                      <Table.Cell style={{ borderLeft: '0.5px solid #e8e9e9' }}>
                        <NameBlock>{train && train.title}</NameBlock>
                      </Table.Cell>
                      <Table.Cell style={{ borderLeft: '0.5px solid #e8e9e9' }}>
                        <NameBlock>{train && train.complexity_training.name}</NameBlock>
                      </Table.Cell>
                      <Table.Cell style={{ borderLeft: '0.5px solid #e8e9e9' }}>
                        <NameBlock>{train && train.type_video_training.name}</NameBlock>
                      </Table.Cell>
                      <Table.Cell style={{ borderLeft: '0.5px solid #e8e9e9' }}>
                        <NameBlock>
                          {train && train.gears.map((gear) => gear.name + ', ')}
                        </NameBlock>
                      </Table.Cell>
                      <Table.Cell style={{ borderLeft: '0.5px solid #e8e9e9' }}>
                        <NameBlock>{train && train.description}</NameBlock>
                      </Table.Cell>

                      <Table.Cell>
                        <ButtonBlock>
                          <PlayButton
                            onClick={() => showVideo(train.video_file.url)}
                            setIsVideoModalOpen={true}
                          >
                            ▶
                          </PlayButton>
                          <EditButton
                            onClick={() => onEditClick(train)}
                            to={`/youslim2.0/CreateTraining/${train.id}/edit`}
                            target="_blank"
                          >
                            <Img src={EditIcon} alt="edit" />
                          </EditButton>

                          <DeleteButton onClick={() => confirmDeleting(train.title, train.id)}>
                            x
                          </DeleteButton>
                        </ButtonBlock>
                      </Table.Cell>
                    </React.Fragment>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        ) : (
          <LoaderBlock>
            {isSearchTrainingLoading ? (
              <Loader active={isSearchTrainingLoading} inline="centered" />
            ) : (
              <H2>Тренировки не найдены</H2>
            )}
          </LoaderBlock>
        )}
      </TableBlock>
      <DeleteConfirmPopup
        isOpen={isShowDeletePopup}
        title={trainCurrentName}
        onCancel={() => setIsShowDeletePopup(false)}
        onDelete={onDelete}
        isTrainingHasVideo={isTrainingDelete}
      />
      <VideoModal isModalOpen={isVideoModalOpen} setIsModalOpen={setIsVideoModalOpen} />
      <FooterBlock />
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  const {
    complexity,
    trainingType,
    trainingGears,
    training,
    isSearchTrainingLoading,
    isVideoModalOpen,
    checkShouldTrainBeDeleted,
  } = state.newYouslim;

  return {
    complexity,
    trainingType,
    trainingGears,
    training,
    isSearchTrainingLoading,
    isVideoModalOpen,
    checkShouldTrainBeDeleted,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getComplexity: () => {
      dispatch(action.getComplexity());
    },
    getTrainingType: () => {
      dispatch(action.getTrainingType());
    },
    getTrainingGears: () => {
      dispatch(action.getTrainingGears());
    },
    getTrainingListByName: (name, type_video, complexity, tags) => {
      dispatch(action.getTrainingListByName(name, type_video, complexity, tags));
    },
    deleteTraining: (id) => {
      dispatch(action.deleteTraining(id));
    },
    setIsVideoModalOpen: (isOpen) => {
      dispatch(action.setIsVideoModalOpen(isOpen));
    },
    setActiveVideo: (activeVideo) => {
      dispatch(action.setActiveVideo(activeVideo));
    },
    setCurrentTraining: (training) => {
      dispatch(action.setCurrentTraining(training));
    },
    checkShouldTrainBeDeleted: (id) => {
      dispatch(action.checkShouldTrainBeDeleted(id));
    },
    getTrainById: (id) => {
      dispatch(action.getTrainById(id));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateTrainingList);



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/CreateTrainingList/index.jsx